import { useQuery } from "@tanstack/react-query";

import getTbiApi from "@/api/api-v1";
import { Status as ApiStatus } from "@/api/models";

interface StatusAuthenticated extends NonNullable<Omit<ApiStatus, "sendLoginLink">> {
  authenticated: true;
}

interface StatusNotAuthenticated extends NonNullable<Pick<ApiStatus, "sendLoginLink">> {
  authenticated: false;
}

type Status = StatusAuthenticated | StatusNotAuthenticated;

export const getStatus = () =>
  getTbiApi().getQueryOptions({
    queryKey: ["status"],
    queryFn: async (): Promise<Status> => await getTbiApi().StatusApi.statusRetrieve(),
  });

export const useStatusQuery = () => useQuery(getStatus());
